// extracted by mini-css-extract-plugin
export default {"modalTitle":"CreateFormPopup_modalTitle__iJosm","closeModalButton":"CreateFormPopup_closeModalButton__y3lmk","buttonSection":"CreateFormPopup_buttonSection__7ikLm"};